/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LinkBusinessUnitRequestDto
 */
export interface LinkBusinessUnitRequestDto {
    /**
     * 
     * @type {string}
     * @memberof LinkBusinessUnitRequestDto
     */
    parentBusinessUnitId: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof LinkBusinessUnitRequestDto
     */
    childBusinessUnitIds: Array<string> | null;
}

/**
 * Check if a given object implements the LinkBusinessUnitRequestDto interface.
 */
export function instanceOfLinkBusinessUnitRequestDto(value: object): value is LinkBusinessUnitRequestDto {
    if (!('parentBusinessUnitId' in value) || value['parentBusinessUnitId'] === undefined) return false;
    if (!('childBusinessUnitIds' in value) || value['childBusinessUnitIds'] === undefined) return false;
    return true;
}

export function LinkBusinessUnitRequestDtoFromJSON(json: any): LinkBusinessUnitRequestDto {
    return LinkBusinessUnitRequestDtoFromJSONTyped(json, false);
}

export function LinkBusinessUnitRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): LinkBusinessUnitRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'parentBusinessUnitId': json['parentBusinessUnitId'],
        'childBusinessUnitIds': json['childBusinessUnitIds'] == null ? null : json['childBusinessUnitIds'],
    };
}

export function LinkBusinessUnitRequestDtoToJSON(json: any): LinkBusinessUnitRequestDto {
    return LinkBusinessUnitRequestDtoToJSONTyped(json, false);
}

export function LinkBusinessUnitRequestDtoToJSONTyped(value?: LinkBusinessUnitRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'parentBusinessUnitId': value['parentBusinessUnitId'],
        'childBusinessUnitIds': value['childBusinessUnitIds'],
    };
}

